var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToBeCreative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 365.98,
    height: 41.454,
    viewBox: "0 0 365.98 41.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 117.676,
    height: 41.454,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 223.001,
    height: 41.454,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_624",
    "data-name": "Grupo 624",
    transform: "translate(-901.162 -6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621",
    transform: "translate(901.162 6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_616",
    "data-name": "Grupo 616",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_560",
    "data-name": "Trazado 560",
    d: "M8.957,0H.073L0,31.093c-.018,6.679,4.211,10.345,9.96,10.361a32.5,32.5,0,0,0,7.063-1.227v-5.61a31.006,31.006,0,0,1-4.951-.343c-1.911-.5-3.192-1.706-3.183-4.666L8.918,16.8l8.536.02.018-6.214-8.536-.02Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_561",
    "data-name": "Trazado 561",
    d: "M88.693,19.285a9.051,9.051,0,0,0,7.09-8.977C95.8,4,90.2.071,81.207.048L62.4,0l-.105,40.94H81.745c9.463.026,15.432-4.282,15.448-11.291a9.983,9.983,0,0,0-8.5-10.363M71.609,7.557l9.112.023c3.5-.048,5.6,1.593,5.6,4.4-.007,2.861-2.116,4.55-5.619,4.541L71.586,16.5ZM80.654,33.4l-9.112-.023.026-9.7,9.111.023c4.321-.046,7.005,1.772,7,4.75-.009,3.154-2.7,4.96-7.024,4.949",
    transform: "translate(-37.038 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_562",
    "data-name": "Trazado 562",
    d: "M175.942,24.184l19.668.05.018-7.644-19.667-.051.023-8.872,21.884.057L197.888,0H166.676V40.948h31.751l.018-7.658-22.528-.057Z",
    transform: "translate(-99.102 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    "data-name": "Trazado 563",
    d: "M271.129,78.251a4.865,4.865,0,1,0,4.853,4.89,4.785,4.785,0,0,0-4.853-4.89m-.021,8.785a3.931,3.931,0,1,1,3.9-3.9,3.855,3.855,0,0,1-3.9,3.9",
    transform: "translate(-158.307 -46.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_564",
    "data-name": "Trazado 564",
    d: "M277.77,85.895c0-.9-.729-1.481-1.822-1.484L273.88,84.4l-.012,4.466.973,0,0-1.432.729,0,1.258,1.436,1.168,0-1.382-1.533a1.5,1.5,0,0,0,1.152-1.453m-1.831.674-1.092,0,0-1.284,1.092,0c.506,0,.846.246.845.632s-.341.654-.848.652",
    transform: "translate(-162.836 -50.185)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_626",
    "data-name": "Grupo 626",
    transform: "translate(1044.142 6264.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_625",
    "data-name": "Grupo 625",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_571",
    "data-name": "Trazado 571",
    d: "M0,20.726C0,8.178,9.354,0,18.1,0c9,0,16.13,6.106,17.042,13.947H30.29C29.633,6.386,25.285.5,18.1.559S4.55,6.665,4.55,18.373c0,11.036,5.715,20.839,15.729,20.839,8.241,0,13.247-6.386,14.563-13.948h.506C33.932,33.5,28.015,41.453,18.255,41.453,8.749,41.453,0,32.882,0,20.726",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_572",
    "data-name": "Trazado 572",
    d: "M47.553,11.291c-7.281,0-12.895,3.023-12.895,14.228V35.6H38.7v.559H25.86V35.6h4.045V7.593H25.86V7.033h8.8v13.22c1.669-8.234,7.13-13.725,12.895-14.34Z",
    transform: "translate(13.946 4.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_573",
    "data-name": "Trazado 573",
    d: "M59.524,5.913c4.652,0,9.051,2.017,9.051,6,0,7.17-14.563,4.592-14.614,9.8-.051,4.93,12.895,2.577,12.895,9.523,0,3.584-3.388,6.05-8.646,6.05-7.838,0-15.525-5.155-15.525-14.958,0-11.315,9.508-16.414,16.84-16.414M47.488,21.207c0,10.083,7.181,14.956,12.187,14.956,3.691,0,6.676-1.736,6.676-4.873,0-6.555-12.895-3.922-12.895-9.578,0-5.1,10.418-4.427,10.418-11.2,0-2.353-1.265-4.036-4.35-4.036-5.36,0-12.036,5.042-12.036,14.734",
    transform: "translate(23.02 4.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_574",
    "data-name": "Trazado 574",
    d: "M81.906,26.528c-1.264,5.434-5.461,10.756-11.479,10.756-3.64,0-7.536-1.9-7.536-6.275,0-7.9,13.1-6.106,13.1-11.2,0-4.65-10.871-1.064-10.871-7.787,0-4.145,4.145-6.106,8.9-6.106,6.371,0,12.693,4.2,12.693,12.661V35.6h4.045v.561h-8.8V26.528Zm.051-4.537V16.5c0-7.675-4.248-10.028-8.243-10.028-3.844,0-8.091,1.627-8.091,5.547,0,6.162,10.872,2.408,10.872,7.787,0,4.817-8.748,4.425-8.748,11.034,0,3.081,1.87,5.1,4.652,5.1,5.006,0,9.558-6.5,9.558-13.948",
    transform: "translate(33.918 4.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_575",
    "data-name": "Trazado 575",
    d: "M90.876,25.256C91.381,30.8,101.7,28.5,101.7,35.338c0,3.081-2.075,5.491-6.119,5.491-4.5,0-9.407-2.969-9.407-9.861V11.138H82.936v-.561h1.719c3.59,0,5.665-2.241,5.665-7.45V.887h.5v9.69h10.113v.561H90.825Zm10.315,10.083c0-5.658-8.091-4.37-10.266-8.291v4.481c0,5.1,1.062,8.739,5.107,8.739a4.828,4.828,0,0,0,5.158-4.93",
    transform: "translate(44.728 0.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_576",
    "data-name": "Trazado 576",
    d: "M97.558,40.332v-.559H101.6V11.762H97.558V11.2h8.8v28.57H110.4v.559Zm2.831-36.861A3.227,3.227,0,0,1,103.475,0a3.266,3.266,0,0,1,3.134,3.472,3.266,3.266,0,0,1-3.134,3.473,3.228,3.228,0,0,1-3.086-3.473",
    transform: "translate(52.614 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_577",
    "data-name": "Trazado 577",
    d: "M138.395,7.13h-4.045L123.172,35.7h-.5L111.594,7.13h-4.047V6.57H120.8V7.13H116.75l8.5,21.9,8.546-21.9h-4.045V6.57h8.646Z",
    transform: "translate(58.001 4.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_578",
    "data-name": "Trazado 578",
    d: "M144.891,5.913c4.652,0,9.051,2.017,9.051,6,0,7.17-14.563,4.592-14.614,9.8-.051,4.93,12.895,2.577,12.895,9.523,0,3.584-3.388,6.05-8.646,6.05-7.838,0-15.525-5.155-15.525-14.958,0-11.315,9.508-16.414,16.84-16.414M132.855,21.207c0,10.083,7.181,14.956,12.187,14.956,3.691,0,6.676-1.736,6.676-4.873,0-6.555-12.895-3.922-12.895-9.578,0-5.1,10.418-4.427,10.418-11.2,0-2.353-1.265-4.036-4.35-4.036-5.36,0-12.036,5.042-12.036,14.734",
    transform: "translate(69.059 4.171)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBeCreative);
export default __webpack_public_path__ + "static/media/toBeCreative.409aac60349f21cfe56da3ffb901eb84.svg";
export { ForwardRef as ReactComponent };